import React, {
  useCallback,
  useContext,
  useEffect,
  useState
} from 'react';
import { useMutation } from '@apollo/client';

import { UserContext } from 'components/Providers/Providers';
import { useCommittedCapacityContext } from '../../context/committed-capacity.context';

import BookedTender from '../BookedTender/BookedTender';
import DeclinedTender from '../ProcessingTender/DeclinedTender/DeclinedTender';
import { CHANGE_STATUS_BOOK_TENDER } from 'api/mutations';
import CommittedCapacityNoResult from '../CommittedCapacityNoResult/CommittedCapacityNoResult';
import { CommittedCapacityLandingPageSpinner } from '../LandingPage/LandingPage';

export default function CommittedCapacityComplete() {
  const currentUser = useContext(UserContext);
  const {
    carrierId,
    isLoadExpired,
    shouldBeBooked,
    tenderDetails,
    tenderNumber,
    wasTenderMarkedToBeBooked,
    wasTenderMarkedToBeDeclined
  } = useCommittedCapacityContext();
  const [errorMessage, setErrorMessage] = useState('');
  const [loadingMessage, setLoadingMessage] = useState('');

  const [ changeStatusBookTender ] = useMutation(CHANGE_STATUS_BOOK_TENDER, {
    onCompleted: () => {
      setLoadingMessage('');
      setErrorMessage('');
    },
    onError: (error) => {
      setLoadingMessage('');
      setErrorMessage(error.message);
    },
    context: {
      timeout: 100000
    }
  });

  const handleChangeTenderStatus = useCallback((isAccepted: boolean) => {
    changeStatusBookTender({
      variables: {
        loadTenderId: tenderNumber,
        isLoadUpdated: tenderDetails.isLoadUpdated,
        isAccepted: tenderDetails.isLoadUpdated ? '' : String(isAccepted)
      }
    });
  }, [changeStatusBookTender, tenderNumber, tenderDetails]);

  useEffect(() => {
    if (currentUser.UserId && tenderNumber && isLoadExpired !== null) {
      if (wasTenderMarkedToBeDeclined) {
        setLoadingMessage('Updating Tender status');
        handleChangeTenderStatus(false)
        ;
      }
    }
  }, [
    currentUser.UserId,
    handleChangeTenderStatus,
    isLoadExpired,
    shouldBeBooked,
    tenderNumber,
    wasTenderMarkedToBeDeclined,
    tenderDetails
  ]);

  if (loadingMessage) {
    return <CommittedCapacityLandingPageSpinner message={loadingMessage} />
  }

  if (errorMessage) {
    return (
      <CommittedCapacityNoResult subtitle={errorMessage} />
    );
  }

  return (
    <>
      {
        wasTenderMarkedToBeBooked && (
          <BookedTender
            carrierId={carrierId}
            tenderDetails={tenderDetails}
            tenderNumber={tenderNumber}
            changeTenderStatus={
              () => handleChangeTenderStatus(true)
            }
          />
        )
      }
      {
        wasTenderMarkedToBeDeclined && (
          <DeclinedTender />
        )
      }
    </>
  );
}
